<template>
  <div v-if="can('assign-role-to-user')">
    <h2>Assign Role</h2>
    <div class="custom-form">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <div class="form-group my-4">
            <label for="name">User<Astrik /></label>
            <input
              type="text"
              disabled
              v-model="name"
              class="form-control"
              id="name"
            />
          </div>

          <ValidationProvider
            name="assigned_roles"
            rules=""
            v-slot="{ errors }"
          >
            <div class="form-group my-4">
              <label for="assigned_roles">Roles</label>
              <table class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Assign</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="col-md-4" v-for="r in all_roles" :key="r.id">
                    <td>{{ r.name }}</td>
                    <td>
                      <input
                        type="checkbox"
                        v-model="assigned_roles"
                        :value="r.id"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <span>{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
          <div class="button-form-group">
            <button type="submit" class="btn btn-success">Assign</button>
            <router-link
              class="text-decoration-none btn btn-danger pull-right"
              :to="{
                name: 'UserList',
              }"
              >Cancel
            </router-link>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignPermissionToRole",
  data() {
    return {
      submitting: false,
      all_roles: [],
      assigned_roles: [],
      user: null,
      name: "",
    };
  },
  mounted() {
    // if (this.can("assign-role-to-user")) {
    this.getUserWithRoles();
    // } else {
    //   this.$router.push({ name: "Dashboard" });
    // }
  },
  methods: {
    getUserWithRoles() {
      this.submitting = true;
      this.$http
        .get("user/" + this.$route.params.id + "/with-roles")
        .then((res) => {
          if (res.data.status == 1) {
            this.user = res.data.data.user;
            this.all_roles = res.data.data.all_roles;
            this.assigned_roles = res.data.data.assigned_roles;
            this.name = this.user.name;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    submit() {
      this.submitting = true;
      this.$http
        .post("user/assign-role/" + this.$route.params.id, {
          roles: this.assigned_roles,
        })
        .then((res) => {
          if (res.data.status == 1) {
            this.$router.push({
              name: "UserList",
            });
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
